import { Module } from "vuex-class-modules";
import { CollectionStore } from "../../../../../common/src/stores/CollectionStore";
import { QuiltyInsightsListItem } from "@gsx/common/src/types/http/admin/quiltyInsights";

@Module()
export class QuiltyInsightsCollectionStore extends CollectionStore<QuiltyInsightsListItem> {
    sort: keyof QuiltyInsightsListItem = "title";
}
